<template>
  <b-card title="Special Bonus">
    <special-bonus-filter @filtersUpdated="filtersChangeHandler" />
    <special-bonus-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import dateMixin from '@/mixins/dateMixin'
import SpecialBonusFilter from '@/components/Sales/SpecialBonus/SpecialBonusFilter.vue'
import SpecialBonusList from '@/components/Sales/SpecialBonus/SpecialBonusList.vue'

export default {
  components: {
    BCard,
    SpecialBonusFilter,
    SpecialBonusList,
  },
  mixins: [dateMixin],
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}

</script>
